import { render } from "./ConsentBanner.vue?vue&type=template&id=b4fa9780&scoped=true&ts=true"
import script from "./ConsentBanner.vue?vue&type=script&lang=ts"
export * from "./ConsentBanner.vue?vue&type=script&lang=ts"

import "./ConsentBanner.vue?vue&type=style&index=0&id=b4fa9780&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4fa9780"]])

export default __exports__